import { UserProfile } from "@/app/@types";
import { supabase } from "../supabase-client";

export const getUserProfile = async (
  userId: string
): Promise<UserProfile | null> => {
  try {
    if (!userId) {
      console.error("User ID is required");
      return null;
    }

    const { data, error } = await supabase
      .from("user_profiles")
      .select("*")
      .eq("id", userId)
      .single();

    if (error) {
      console.error("Error fetching user profile:", error);
      return null;
    }

    if (!data) {
      console.error("No profile found for user");
      return null;
    }

    return data;

  } catch (error) {
    console.error("Unexpected error fetching user profile:", error);
    return null;
  }
};